import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import ClockWidget from './ClockWidget';
import { useTranslation } from '../context/LanguageContext';

const { FiShield, FiGlobe } = FiIcons;

const Header = () => {
  const { lang, setLang, t } = useTranslation();

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          <div className="flex items-center justify-between w-full lg:w-auto">
            <div className="flex items-center space-x-3">
              <div className="bg-indigo-600 p-2.5 rounded-xl shadow-lg shadow-indigo-200">
                <SafeIcon icon={FiShield} className="text-2xl text-white" />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
                  {t('app_title')}
                </h1>
                <div className="flex items-center space-x-2">
                  <span className="flex h-2 w-2 rounded-full bg-green-500 animate-pulse"></span>
                  <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">{t('status_active')}</p>
                </div>
              </div>
            </div>

            {/* Language Switcher - Mobile */}
            <div className="lg:hidden">
              <LanguageSwitcher lang={lang} setLang={setLang} />
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <ClockWidget />
            {/* Language Switcher - Desktop */}
            <div className="hidden lg:block">
              <LanguageSwitcher lang={lang} setLang={setLang} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const LanguageSwitcher = ({ lang, setLang }) => (
  <div className="flex items-center bg-slate-100 p-1 rounded-xl border border-slate-200">
    <button 
      onClick={() => setLang('en')}
      className={`px-3 py-1.5 text-[10px] font-black rounded-lg transition-all ${lang === 'en' ? 'bg-white text-indigo-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
    >
      EN
    </button>
    <button 
      onClick={() => setLang('ceb')}
      className={`px-3 py-1.5 text-[10px] font-black rounded-lg transition-all ${lang === 'ceb' ? 'bg-white text-indigo-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
    >
      CEB
    </button>
  </div>
);

export default Header;